<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row">

                <div class="mb-3">
                    <h2>Our Publications</h2>
                    <p class="font-weight-500">Special mention</p>
                </div>
                <div class="col-sm-12 py-3 px-0">
    <h6>Jixian Zhou, Fang Dong, Ruijun Huang, Hengjie Cao, Mengyi Chen, Yifeng Yang, Anrui Chen, Mingzhi Dong, Yujiang Wang, Dongsheng Li, David A. Clifton, Qin Lv, Rui Zhu, Chun Zhang, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
    <h6 class="font-weight-bold pub-dot">“Oracle-MoE: Locality-preserving Routing in the Oracle Space for Memory-constrained Large Language Model Inference”
        <a href="/memx-website/static/pub/Low_Variance_MoE.pdf" target="_blank">[PDF]</a>
    </h6>
    <h6>in Proceedings of the International Conference on Machine Learning <span class="font-weight-bold">(ICML)</span>, July 2025.</h6>
</div>
                <div class="col-sm-12 py-3 px-0">
                    <h6>Chenyu Wang, Shuo Yan, Yixuan Chen, Xianwei Wang, Yujiang Wang, Mingzhi Dong, Xiaochen Yang, Dongsheng Li, Rui Zhu, David A. Clifton, Robert P. Dick, Qin Lv, Fan Yang, Tun Lu, Ning Gu, Li Shang, </h6>
                    <h6 class="font-weight-bold pub-dot">“Denoising Reuse: Exploiting Inter-frame Motion Consistency for Efficient Video Generatio”<a href="https://ieeexplore.ieee.org/document/10915618" target="_blank">[HTML]</a></h6>
                    <h6>IEEE Transactions on Circuits and Systems for Video Technology <span
                            class="font-weight-bold">(TCSVT)</span></h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Xiang Luo, Chen Zhang, Chenbo Geng, Yanzhi Yi, Jiahui Hu, Renwei Zhang, Zhen Zhang, Gianpietro Consolaro, Fan Yang, Tun Lu, Ning Gu, Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“TSCompiler: efficient compilation framework for dynamic-shape models[J],”</h6>
                    <h6>Science China Information Sciences <span
                            class="font-weight-bold">(SCIS)</span>, 2024(10).</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Fang Dong, Mengyi Chen, Jixian Zhou, Yubin Shi, Yixuan Chen, Mingzhi Dong, Yujiang Wang, Dongsheng Li, Xiaochen Yang, Rui Zhu, Robert P. Dick, Qin Lv, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Once Read is Enough: Finetuning-free Language Models with Cluster-guided Sparse Experts for Long-tail Domain Knowledge”
                        <a href="/memx-website/static/pub/Once_Read_is_Enough_Fine.pdf" target="_blank">[PDF]</a>
                    </h6>
                    <h6>in Proceedings Conference on Neural Information Processing Systems <span
                            class="font-weight-bold">(NeurIPS)</span>, December 2024.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Zhenyu Xu, Hailin Xu, Zhouyang Lu, Yingying Zhao, Rui Zhu, Yujiang Wang, Mingzhi Dong, Yuhu
                        Chang, Qin Lv, Robert P. Dick, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Can Large Language Models Be Good Companions? An LLM-Based
                        Eyewear System with Conversational Common Ground,”
                        <a href="https://dl.acm.org/doi/abs/10.1145/3659600" target="_blank">[HTML]</a>
                        <!-- <a href="https://github.com/MemX-Research/CASES" target="_blank">[Dataset]</a>  -->
                    </h6>
                    <h6>ACM Interactive Mobile Wearable & Ubiquitous Technologies <span
                            class="font-weight-bold">(IMWUT)</span>, Vol. 8, No. 2, pp. 1-41, June 2024. </h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yubin Shi, Yixuan Chen, Mingzhi Dong, Xiaochen Yang, Dongsheng Li, Yujiang Wang, Robert Dick,
                        Qin Lv, Yingying Zhao, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Train Faster, Perform Better: Modular Adaptive Training in
                        Over-Parameterized Models,”
                        <a href="https://neurips.cc/virtual/2023/poster/71018" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings Conference on Neural Information Processing Systems <span
                            class="font-weight-bold">(NeurIPS)</span>, December 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Maya Okawa, Ekdeep S. Lubana, Robert P. Dick, and Hidenori Tanaka,</h6>
                    <h6 class="font-weight-bold pub-dot">“Compositional abilities emerge multiplicatively: Exploring
                        diffusion models on a synthetic task,”
                        <a href="https://openreview.net/pdf?id=ZXH8KUgFx3" target="_blank">[PDF]</a>
                    </h6>
                    <h6>in Proceedings Conference on Neural Information Processing Systems <span
                            class="font-weight-bold">(NeurIPS)</span>, December 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Xiangyao Qi, Qi Lu, Wentao Pan, Yingying Zhao, Rui Zhu, Mingzhi Dong, Yuhu Chang, Qin Lv, Robert
                        P. Dick, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“CASES: A Cognition-Aware Smart Eyewear System for
                        Understanding How People Read,”
                        <a href="https://dl.acm.org/doi/10.1145/3610910" target="_blank">[PDF]</a>
                        <a href="https://github.com/MemX-Research/CASES" target="_blank">[Dataset]</a>
                    </h6>
                    <h6>ACM Interactive Mobile Wearable & Ubiquitous Technologies <span
                            class="font-weight-bold">(IMWUT)</span>, Vol. 7, No. 3, pp. 1-31, September 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Robert P. Dick, Rob Aitken, Jace Mogill, John Paul Strachen, Kirk Bresniker, Wei Lu, Yorie
                        Nakahira, Zhiyong Li, Matthew J. Marinella, William Severa, Alec Talin, Craig Vineyard, Suhas
                        Kumar, Christian Mailhiot, and Lennie Klebanoff, </h6>
                    <h6 class="font-weight-bold pub-dot">“Research Challenges for Energy-Efficient Computing in
                        Automated Vehicles,”
                        <a href="https://robertdick.org/publications/dick23mar.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>IEEE Computer<span class="font-weight-bold"></span>, Vol. 56, March 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana, Eric J. Bigelow, Robert P. Dick, David Krueger, and Hidenori Tanaka,</h6>
                    <h6 class="font-weight-bold pub-dot">“Mechanistic Mode Connectivity,”
                        <a href="https://robertdick.org/publications/lubana23may.pdf" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings International Conference on Machine Learning <span
                            class="font-weight-bold">(PMLR)</span>, May 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yixuan Chen, Yubin Shi, Mingzhi Dong, Xiaochen Yang, Dongsheng Li, Yujiang Wang, Robert Dick,
                        Qin Lv, Yingying Zhao, Fan Yang, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Over-parameterized model optimization with Polyak-Łojasiewicz
                        condition,”
                        <a href="https://openreview.net/pdf?id=aBIpZvMdS56" target="_blank">[PDF]</a>
                    </h6>
                    <h6>in Proceedings of the 11th International Conference on Learning Representations <span
                            class="font-weight-bold">(ICLR)</span>, May 2023.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yingying Zhao, Ning Li, Wentao Pan, Yujiang Wang, Mingzhi Dong, Xianghua Ding, Qin Lv, Robert P.
                        Dick, Dongsheng Li, Fan Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Unveiling causal attention in dogs' eyes with smart eyewear,”
                        <a href="https://dl.acm.org/doi/10.1145/3569490" target="_blank">[PDF]</a>
                        <a href="https://github.com/MemX-Research/DogsView" target="_blank">[Dataset]</a>
                    </h6>
                    <h6>ACM Interactive Mobile Wearable & Ubiquitous Technologies <span
                            class="font-weight-bold">(IMWUT)</span>, Vol. 6, No. 4, pp. 1-33, December 2022.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana, Puja Trivedi, Danai Koutra, and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“How do Quadratic Regularizers Prevent Catastrophic Forgetting:
                        The Role of Interpolation,”
                        <a href="https://robertdick.org/publications/lubana22aug.pdf" target="_blank">[PDF]</a>
                    </h6>
                    <h6>in Proceedings Conference on Lifelong Learning Agents <span
                            class="font-weight-bold">(PMLR)</span>, August 2022.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yixuan Chen, Yubin Shi, Dongsheng Li, Yujiang Wang, Mingzhi Dong, Yingying Zhao, Robert Dick,
                        Qin Lv, Fan Yang, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Recursive disentanglement network,” <a
                            href="https://openreview.net/pdf?id=CSfcOznpDY" target="_blank">[PDF]</a> </h6>
                    <h6>in Proceedings of the 10th International Conference on Learning Representations <span
                            class="font-weight-bold">(ICLR)</span>, April 2022.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yingying Zhao, Yuhu Chang, Yutian Lu, Mingzhi Dong, Yujiang Wang, Qin Lv, Robert P. Dick, Fan
                        Yang, Tun Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“Do Smart Glasses Dream of Sentimental Visions? Deep
                        Emotionship Analysis for Eyewear Devices,”
                        <a href="https://arxiv.org/pdf/2201.09933" target="_blank">[PDF]</a>
                        <a href="https://github.com/memx-research/emoship" target="_blank">[Dataset]</a>
                    </h6>
                    <h6>ACM Interactive Mobile Wearable & Ubiquitous Technologies <span
                            class="font-weight-bold">(IMWUT)</span>, Vol. 6, No. 1, pp. 1-29, March 2022.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana, Robert P. Dick, and Hidenori Tanaka,</h6>
                    <h6 class="font-weight-bold pub-dot">“Beyond BatchNorm: Towards a Unified Understanding of
                        Normalization in Deep Learning,”
                        <a href="https://robertdick.org/publications/lubana21dec.pdf" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings Conference on Neural Information Processing Systems <span
                            class="font-weight-bold">(NeurIPS)</span>, December 2021.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yuhu Chang, Yingying Zhao, Mingzhi Dong, Yujiang Wang, Yutian Lu, Qin Lv, Robert P. Dick, Tun
                        Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“MemX: An attention-aware smart eyewear system for personalized
                        moment auto-capture,”
                        <a href="https://arxiv.org/pdf/2105.00916" target="_blank">[PDF]</a>
                        <a href="https://www.youtube.com/watch?v=sJMq_XlXr3o" target="_blank">[Video]</a>
                    </h6>
                    <h6>ACM Interactive Mobile Wearable & Ubiquitous Technologies <span
                            class="font-weight-bold">(IMWUT)</span>, Vol. 5, No. 2, pp. 1-23, June 2021.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“A Gradient Flow Framework For Analyzing Network Pruning,”
                        <a href="https://robertdick.org/publications/lubana21may.pdf" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings International Conference on Learning Representation <span
                            class="font-weight-bold">(ICLR)</span>, May 2021.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yingying Zhao, Mingzhi Dong, Yujiang Wang, Da Feng, Qin Lv, Robert P. Dick, Dongsheng Li, Tun
                        Lu, Ning Gu, and Li Shang,</h6>
                    <h6 class="font-weight-bold pub-dot">“A reinforcement-learning-based energy-efficient framework for
                        multi-task video analytics pipeline,” <a href="https://arxiv.org/pdf/2104.04443"
                            target="_blank">[PDF]</a> </h6>
                    <h6>IEEE Transactions on Multimedia <span class="font-weight-bold">(TMM) </span>, Vol. 24, pp.
                        2150-2163, April 2021.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Yuhu Chang, Changyang He, Yingying Zhao, Tun Lu, and Ning Gu,</h6>
                    <h6 class="font-weight-bold pub-dot">“A High-Frame-Rate Eye-Tracking Framework for Mobile Devices,”
                        <a href="https://hechangyang.com/papers/ICASSP_GazeHFR_2021.pdf" target="_blank">[PDF]</a> </h6>
                    <h6>IEEE International Conference on Acoustics, Speech and Signal Processing <span
                            class="font-weight-bold">(ICASSP)</span>, pp. 1445-1449, June 2021.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Benjamin Simpson, Ekdeep S. Lubana, Yuchen Liu, and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“Intelligent Scene Caching to Improve Accuracy for
                        Energy-Constrained Embedded Vision,”
                        <a href="https://robertdick.org/publications/simpson20jun.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings of the Conference on Computer Vision and Pattern Recognition Workshops <span
                            class="font-weight-bold">(CVPRW)</span>, pp. 724-725, June 2020.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana, Robert P. Dick, Vinayak Aggarwal, and Pyari Mohan Pradhan,</h6>
                    <h6 class="font-weight-bold pub-dot">“Minimalistic image signal processing for deep learning
                        applications,”
                        <a href="https://robertdick.org/publications/lubana19sep.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings International Conference on Image Processing <span
                            class="font-weight-bold">(ICIP)</span>, September 2019.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana, Vinayak Aggarwal, and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“Machine Foveation: an application-aware compressive sensing
                        framework,”
                        <a href="https://robertdick.org/publications/lubana19mar.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings Data Compression Conference <span class="font-weight-bold">(DCC)</span>, March
                        2019.</h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“Digital Foveation: an energy-aware machine vision framework,”
                        <a href="https://robertdick.org/publications/lubana18nov.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>IEEE Transactions Computer-Aided Design of Integrated Circuits and Systems <span
                            class="font-weight-bold">(TCAD)</span>, pp. 2371-2380, November 2018. </h6>
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6>Ekdeep S. Lubana and Robert P. Dick,</h6>
                    <h6 class="font-weight-bold pub-dot">“Digital Foveation: an energy-aware machine vision framework,”
                        <a href="https://robertdick.org/publications/lubana18oct.html" target="_blank">[HTML]</a>
                    </h6>
                    <h6>in Proceedings International Conference Hardware/Software Codesign and System Synthesis <span
                            class="font-weight-bold">(CODES/ISSS)</span>, October 2018.</h6>
                </div>

                <!-- <div class="col-sm-12 py-3 px-0 text-center">
                <a href="https://cscw.fudan.edu.cn/kycg/list.htm" target="_blank" class="btn btn-white mt-4">See more publications</a>
            </div> -->

                <!-- <div class="row py-3 align-items-center mb-1">
                <div class="col-sm-1">
                    <small class="text-uppercase text-center font-weight-bold">*</small>
                </div>
                <div class="col-sm-11 ml--36">
                    <h6>Yuhu Chang, Changyang He, Yingying Zhao, Tun Lu, Ning Gu.</h6>
                    <h6 class="font-weight-bold">A High-Frame-Rate Eye-Tracking Framework for Mobile Devices. <a href="https://hechangyang.com/papers/ICASSP_GazeHFR_2021.pdf" target="_blank">[PDF]</a> </h6>
                    <h6>The 2021 IEEE International Conference on Acoustics, Speech and Signal Processing (ICSSP), 2021.</h6>
                </div>
            </div> -->
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style></style>
